import { api } from "./client";

export interface ChatChannel {
  id: number;
  code: string;
  name: string;
  sort_order: number;
}

export interface ChatMessage {
  id: number;
  channel_code: string;
  channel_name: string;
  user_id: number;
  display_name: string;
  text: string;
  created_at: string;
}

export const chatApi = {
  channels: () => api.get<ChatChannel[]>("/chat/channels"),
  messages: (channelCodes: string[], limit = 50) =>
    api.get<ChatMessage[]>(`/chat/messages?channels=${encodeURIComponent(channelCodes.join(","))}&limit=${limit}`),
  post: (channel_code: string, text: string) =>
    api.post<ChatMessage>("/chat/messages", { channel_code, text }),

  getChannels: () => api.get<ChatChannel[]>("/chat/channels"),
  getMessages: (params: {
    channels: string[];
    limit?: number;
    afterId?: number;
    beforeId?: number;
  }) => {
    const search = new URLSearchParams({
      channels: params.channels.join(","),
      limit: String(params.limit ?? 50),
    });
    if (params.afterId != null) search.set("after_id", String(params.afterId));
    if (params.beforeId != null) search.set("before_id", String(params.beforeId));
    return api.get<ChatMessage[]>(`/chat/messages?${search.toString()}`);
  },
  postMessage: (channelCode: string, text: string) =>
    api.post<ChatMessage>("/chat/messages", { channel_code: channelCode, text }),
};
